import PlaylistGrid from "@components/Players/PlaylistGrid";
import QueryFetchStatePage from "@components/QueryFetchStatePage";
import Divider from "@components/shared/Divider";
import { Button } from "@components/ui/button";
import { usePlaylists } from "@hooks/usePlaylists";
import { usePublicPlaylists } from "@hooks/usePublicPlaylists";
import { ScreenPlayingOptionType } from "@hooks/useScreens/types";
import generateAssetUrl from "@utils/generateAssetUrl";
import { cn } from "@utils/index";
import Link from "next/link";
import { MdAdd, MdDone } from "react-icons/md";
import { Playlist } from "types";

function SelectPlaylist({
  selected,
  onPreview,
  listOnly = false,
}: {
  selected?: ScreenPlayingOptionType;
  onSelected: (opt: ScreenPlayingOptionType) => void;
  onPreview(
    opt: ScreenPlayingOptionType,
  ): void;
  listOnly?: boolean;
}) {
  const { playlists, playlistsFetchStatus, getPlaylists } = usePlaylists();
  const {
    playlists: publicPlaylists,
    playlistsFetchStatus: publicplaylistsFetchStatus,
    getPlaylists: getPublicPlaylists,
  } = usePublicPlaylists();

  return (
    <QueryFetchStatePage
      queryFetchStatus={playlistsFetchStatus}
      onRetry={getPlaylists}
    >
      <QueryFetchStatePage
        queryFetchStatus={publicplaylistsFetchStatus}
        onRetry={getPublicPlaylists}
      >
        <div className="flex h-full w-full flex-col items-center gap-2 overflow-x-clip pt-2">
          {!!playlists.length && (
            <>
              {_playlistsGrid({
                title: "My Playlists",
                showCreateButton: true,
                playlists: playlists.map((l) => ({
                  ...l,
                  id: l.id,
                  name: l.name ?? "",
                  isSelected: selected?.id === l.id,
                  onClick() {
                    onPreview(
                      {
                        type: "playlist",
                        ...l,
                      }
                    );
                  },
                  onPreview() {
                    onPreview(
                      {
                        type: "playlist",
                        ...l,
                      }
                    );
                  },
                })),
              })}
            </>
          )}
          {playlists.length > 0 && <Divider />}

          {_playlistsGrid({
            playlists: publicPlaylists.map((l) => ({
              ...l,
              id: l.id,
              name: l.name ?? "",
              isSelected: l.id === selected?.id,
              onClick() {
                // clonePlaylist(l);
                onPreview(
                  {
                    type: "playlist",
                    ...l,
                  });
              },
              onPreview() {
                onPreview(
                  {
                    type: "playlist",
                    ...l,
                  });
              },
            })),
            showCreateButton: playlists.length === 0,
            title: "Browse Free Playlists",
          })}
        </div>
      </QueryFetchStatePage>
    </QueryFetchStatePage>
  );

  function _playlistsGrid({
    playlists,
    showCreateButton,
    title,
  }: {
    playlists: (Playlist & {
      id: string;
      name: string;
      image_src?: string;
      onClick: () => void;
      onPreview: () => void;
      isSelected: boolean;
    })[];
    title: string;
    showCreateButton?: boolean;
  }) {
    return (
      <div className="flex w-full flex-col gap-4 sm:gap-2">
        {
          !listOnly && (
            <div className="flex w-full items-center justify-between text-base font-semibold">
              {title}
              <>{showCreateButton ? <>{_createPlaylistButton()}</> : <></>}</>
            </div>
          )
        }

        <div className="grid w-full grid-cols-2 items-center justify-center gap-4 sm:gap-2 px-2 lg:grid-cols-3 xl:grid-cols-4">
          {playlists.map((playlist, idx) => {
            return (
              <button
                className="group flex w-full flex-col items-start pb-2"
                key={`playlist_${idx}_${playlist.id}`}
                onClick={playlist.onClick}
              >
                <div className={cn(
                  "relative h-44 w-full overflow-clip rounded-md bg-lightCard p-4 group-hover:outline group-hover:outline-accentColor dark:bg-darkCard dark:group-hover:outline-darkAccentColor",
                  // listOnly && "h-16",
                )}>
                  {playlist.image_src ? (
                    <img
                      src={
                        playlist.image_src ??
                        generateAssetUrl(undefined, "small")
                      }
                      alt=""
                      className="h-full w-full rounded-md object-cover"
                    />
                  ) : (
                    <PlaylistGrid playlist={playlist} />
                    // <div className="flex h-full w-full flex-col items-center justify-center">
                    //   <div className="rounded-full bg-accentColor bg-opacity-10 p-6 text-3xl text-accentColor dark:bg-darkAccentColor dark:bg-opacity-10 dark:text-darkAccentColor">
                    //     <BsLayoutWtf />
                    //   </div>
                    // </div>
                  )}
                  {/* <div className="absolute w-full h-full bg-black  dark:bg-opacity-30 inset-0 bg-opacity-30 opacity-0 group-hover:opacity-100 flex flex-col justify-center items-center text-lg text-white font-semibold p-4">
                    Use this playlist
                  </div> */}
                </div>
                <div className="flex w-full items-center justify-start pt-2">
                  {
                    !listOnly && (
                      <h1 className="w-full grow truncate text-left  text-sm font-medium">
                        {playlist.name}
                      </h1>
                    )
                  }

                  <Button
                    size="icon"
                    className={playlist.isSelected ? "scale-100" : "scale-0"}
                  >
                    <MdDone />
                  </Button>

                  {/* <Button
                    size="square"
                    variant="ghost"
                    data-tip="Preview"
                    disabled={isPreviewLoading}
                    onClick={(e) => {
                      e.stopPropagation();
                      playlist.onPreview();
                    }}
                  >
                    <MdRemoveRedEye />
                  </Button> */}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  function _createPlaylistButton() {
    return (
      <Link href={"/playlists"} target="_blank" rel="noopener noreferrer">
        <Button size="sm" variant="filled">
          <MdAdd />
          Create a custom Playlist
        </Button>
      </Link>
    );
  }
}

export default SelectPlaylist;
